import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Ore passate a preparare ogni allenamento',
  lines: ['Ogni settimana devi creare nuove lezioni.', 'Scegliere gli esercizi.', 'Preparare progressioni tecniche.', 'Organizzare il riscaldamento.', 'Pianificare la preparazione fisica.', 'Adattare tutto ai diversi livelli dei tuoi ginnasti.', "E prima ancora di iniziare l'allenamento... hai già speso ore davanti al computer."]
}, {
  emoji: '🤔',
  title: 'Non sai mai cosa proporre nella prossima lezione',
  lines: ['Ogni allenamento ti fai sempre le stesse domande...', 'Quali esercizi faccio oggi?', 'Come posso far progredire i miei ginnasti?', 'Quale progressione è la più adatta?', 'Come gestisco un gruppo con livelli diversi?', 'Preparare ogni lezione diventa sempre più complicato.']
}, {
  emoji: '📚',
  title: 'Materiale ovunque... ma niente di organizzato',
  lines: ['Libri.', 'PDF.', 'Video.', 'Appunti.', 'YouTube.', 'Corsi.', 'File salvati sul computer.', 'Hai tantissimo materiale...', 'Ma ogni volta devi cercarlo, adattarlo e ricominciare tutto da capo.', 'Ti manca un unico sistema completo, organizzato e pronto da utilizzare.']
}, {
  emoji: '😩',
  title: 'Meno tempo per allenare davvero',
  lines: ['Tra la preparazione delle lezioni…', 'La pianificazione della stagione…', 'Le schede degli atleti…', 'Le progressioni…', 'Le valutazioni…', "E l'organizzazione degli allenamenti...", 'Rimane sempre meno tempo per ciò che conta davvero:', 'Allenare i tuoi ginnasti e farli migliorare.']
}];
export function PainSection() {
  return <section className="py-8 px-4 sm:px-6 bg-brand-ivory" data-id="element-109">
      <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-center text-brand-navy mb-3 uppercase leading-tight" data-id="element-110">
        Ti Ritrovi in una di Queste Situazioni?
      </h2>

      <p className="text-sm sm:text-base text-brand-text font-medium text-center mb-6 leading-relaxed max-w-xl mx-auto" data-id="element-111">
        Ami allenare la ginnastica artistica…
        <br data-id="element-112" />
        Ma preparare ogni allenamento ti porta via ore ogni settimana.
        <br data-id="element-113" />
        <span className="text-brand-violet font-bold mt-1 block" data-id="element-114">
          Se lavori in società sportive, associazioni, scuole, corsi ricreativi
          o squadre agonistiche, probabilmente ti è già capitato almeno uno di
          questi problemi.
        </span>
      </p>

      <div className="flex flex-col gap-3" data-id="element-115">
        {pains.map((pain, i) => <div key={i} className="bg-white p-4 rounded-lg border-l-4 border-brand-violet shadow-sm flex gap-4 items-start" data-id="element-116">
            <div className="text-2xl leading-none shrink-0 mt-0.5" data-id="element-117">
              {pain.emoji}
            </div>
            <div data-id="element-118">
              <h3 className="text-base font-heading font-bold text-brand-navy mb-2 uppercase tracking-tight leading-tight" data-id="element-119">
                {pain.title}
              </h3>
              <div className="text-brand-text text-sm font-medium leading-relaxed space-y-0.5" data-id="element-120">
                {pain.lines.map((line, j) => <p key={j} data-id="element-121">{line}</p>)}
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}